import { getBrowserInfo } from '@atlaskit/editor-common/browser';
import {
	bindKeymapWithCommand,
	isCapsLockOnAndModifyKeyboardEvent,
	toggleViewChanges,
} from '@atlaskit/editor-common/keymaps';
import { SafePlugin } from '@atlaskit/editor-common/safe-plugin';
import type { ExtractInjectionAPI } from '@atlaskit/editor-common/types/next-editor-plugin';
import { keydownHandler } from '@atlaskit/editor-prosemirror/keymap';
import type { EditorView } from '@atlaskit/editor-prosemirror/view';

import type { TrackChangesPlugin } from '../trackChangesPluginType';

export function keymapPlugin(api?: ExtractInjectionAPI<TrackChangesPlugin>): SafePlugin {
	const list = {};
	const browser = getBrowserInfo();

	// Exclude Firefox browser from keyboard shortcut
	if (!browser.gecko) {
		bindKeymapWithCommand(
			// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
			toggleViewChanges.common!,
			() => {
				const trackChangesState = api?.trackChanges?.sharedState.currentState();
				// Mirror the toolbar button: no changes to show, or another plugin currently owns
				// the diff decorations (e.g. the AI Review moment is visible).
				if (!trackChangesState?.isShowDiffAvailable || trackChangesState?.isToggleChangesDisabled) {
					return false;
				}
				const result = api?.core.actions.execute(api?.trackChanges?.commands.toggleChanges);
				return result ?? false;
			},
			list,
		);
	}

	return new SafePlugin({
		props: {
			handleKeyDown(view: EditorView, event: KeyboardEvent) {
				const keyboardEvent = isCapsLockOnAndModifyKeyboardEvent(event);
				return keydownHandler(list)(view, keyboardEvent);
			},
		},
	});
}
